<template>
  <div style="display: none">
    <div
      class="book"
      style="
        margin: 0;
        padding: 0;
        background-color: rgb(105, 105, 105);
        font-family: arial !important;
        padding-top: 20px;
        padding-bottom: 20px;
      "
    >
      <div style="margin: 0 auto; width: 1000px">
        <div
          ref="dataprint"
          style="margin: 0 !important; padding: 0 !important"
        >
          <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
          <div
            v-for="(page, indexPage) in pages"
            :key="indexPage"
            style="
              position: relative;
              width: 1000px;
              min-height: 1293px;
              background: white;
            "
          >
            <hr />
            <div
              class="subpage"
              style="height: 1250px; padding-top: 20px; overflow: hidden"
            >
              <div style="margin-left: 80px; margin-right: 50px">
                <div v-if="hideQr" style="width: 100%; background-color: red">
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO SIN VALIDEZ LEGAL
                  </h3>
                </div>

                <div
                  v-if="invoiceData.data.header.FeMhEstado == 'RECHAZADO'"
                  style="width: 100%; background-color: red"
                >
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO RECHAZADO POR HACIENDA
                  </h3>
                </div>

                <div
                  v-if="invoiceData.data.header.FeMhEstado == 'INVALIDADO'"
                  style="width: 100%; background-color: red"
                >
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO INVALIDADO POR HACIENDA
                  </h3>
                </div>

                <div
                  style="
                    display: inline-block;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <div
                    style="
                      display: inline-block;
                      margin: 0;
                      padding: 0;
                      width: 40%;
                      vertical-align: top;
                    "
                  >
                    <table
                      style="
                        font-size: 10pt;
                        border-collapse: collapse;
                        width: 100%;
                        display: inline-block;
                        vertical-align: top;
                      "
                    >
                      <tr>
                        <td
                          style="
                            padding-right: 20px;
                            padding-bottom: 5px;
                            color: white !important;
                          "
                        >
                          <img
                            style="
                              max-width: 330px !important;
                              height: auto;
                              max-height: 100px !important;
                            "
                            :src="invoiceData.data.branch.BranchLogoPath"
                            crossorigin="anonymous"
                          />
                        </td>
                      </tr>
                      <tr></tr>
                      <tr
                        v-if="
                          invoiceData.data.branch.BranchBilledInfo == null ||
                          invoiceData.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td
                          style="
                            padding-right: 20px;
                            padding-bottom: 5px;
                            font-size: 12pt;
                          "
                        >
                          <b> {{ invoiceData.data.user.business }}</b>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          invoiceData.data.branch.BranchBilledInfo == null ||
                          invoiceData.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          {{ invoiceData.data.branch.BusinessBillingName }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          invoiceData.data.branch.BranchBilledInfo == null ||
                          invoiceData.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          {{ invoiceData.data.branch.DescActividad }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          invoiceData.data.branch.BranchBilledInfo == null ||
                          invoiceData.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          {{ invoiceData.data.branch.BranchLegalAddress }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          invoiceData.data.branch.BranchBilledInfo == null ||
                          invoiceData.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          Tel. {{ invoiceData.data.branch.BranchPhone }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          invoiceData.data.branch.BranchBilledInfo == null ||
                          invoiceData.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          Whatsapp. {{ invoiceData.data.branch.BranchMobile }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          invoiceData.data.branch.BranchBilledInfo == null ||
                          invoiceData.data.branch.BranchBilledInfo == ''
                        "
                      >
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          {{ invoiceData.data.branch.BranchEmail }}
                        </td>
                      </tr>

                      <tr
                        v-if="
                          invoiceData.data.branch.BranchBilledInfo != null &&
                          invoiceData.data.branch.BranchBilledInfo != ''
                        "
                      >
                        <td
                          style="padding-right: 20px; padding-bottom: 5px"
                          v-html="modifiedBranchBilledInfo"
                        ></td>
                      </tr>

                      <tr>
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          NIT: {{ BillingNit }}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding-right: 20px; padding-bottom: 5px">
                          NRC: {{ BillingNrc }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin: 0;
                      padding: 0;
                      width: 60%;
                      vertical-align: top;
                      box-sizing: border-box;
                    "
                  >
                    <table
                      style="
                        font-size: 10pt;
                        border-collapse: collapse;
                        width: 100%;
                        border: 0.5px solid;
                      "
                    >
                      <tr
                        :style="`background-color: ${
                          specialinvoicescolor || 'gray'
                        }; color: ${
                          specialInvoicesTitleColor || 'white'
                        }; width: 100% !important;`"
                      >
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                            padding-top: 5px;
                            color: white !important;
                            text-align: center;
                          "
                          colspan="2"
                        >
                          {{
                            invoiceData.data.header.InvoiceType == "FCF"
                              ? "FACTURA CONSUMIDOR FINAL"
                              : ""
                          }}
                          {{
                            invoiceData.data.header.InvoiceType == "CCF"
                              ? "CRÉDITO FISCAL"
                              : ""
                          }}
                          {{
                            invoiceData.data.header.InvoiceType == "FNS"
                              ? "FACTURA SUJETO EXCLUIDO"
                              : ""
                          }}
                          {{
                            invoiceData.data.header.InvoiceType == "FEX"
                              ? "FACTURA DE EXPORTACIÓN"
                              : ""
                          }}
                          {{
                            invoiceData.data.header.InvoiceType == "DNC"
                              ? "NOTA DE CRÉDITO"
                              : ""
                          }}
                          {{
                            invoiceData.data.header.InvoiceType == "DND"
                              ? "NOTA DE DÉBITO"
                              : ""
                          }}
                          {{
                            invoiceData.data.header.InvoiceType == "CDD"
                              ? "COMPROBANTE DE DONACIÓN"
                              : ""
                          }}
                          {{
                            invoiceData.data.header.InvoiceType == "DNR"
                              ? "NOTA DE REMISIÓN"
                              : ""
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Código generación:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                            padding-top: 10px;
                          "
                        >
                          {{ invoiceData.data.header.CodigoGeneracion }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Sello de recepción:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ invoiceData.data.header.SelloRecepcion }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Número de control:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ invoiceData.data.header.NumeroControl }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Fecha emisión:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ invoiceData.data.header.InvoiceDate }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Correlativo factura:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          {{ invoiceData.data.header.ID_Invoice }}
                        </td>
                      </tr>
                      <tr v-if="ShowCorrelativeControl">
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                          <b>Correlativo interno:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                          "
                        >
                        {{ invoiceData.data.header.InvoiceType + "-" + invoiceData.data.header.Correlative_ID_Invoice }}
                        </td>
                      </tr>
                      <tr v-if="!hideQr">
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-bottom: 5px;
                            text-align: center;
                          "
                          colspan="2"
                        >
                          <img ref="qrcode" :src="urlQr" />
                        </td>
                      </tr>
                    </table>
                    <table
                      style="
                        font-size: 10pt;
                        border-collapse: collapse;
                        width: 100%;
                      "
                    >
                      <tr>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                        >
                          <b>Modelo de facturación:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                          v-if="
                            invoiceData.data.dteJson.IdentificacionTipoModelo == 1
                          "
                        >
                          Previo
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                          v-if="
                            invoiceData.data.dteJson.IdentificacionTipoModelo == 2
                          "
                        >
                          Diferido
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                        >
                          <b>Tipo de transmisión:</b>
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                          v-if="
                            invoiceData.data.dteJson
                              .IdentificacionTipoOperacion == 1
                          "
                        >
                          Normal
                        </td>
                        <td
                          style="
                            padding-left: 10px;
                            padding-right: 10px;
                            padding-top: 5px;
                            text-align: left;
                          "
                          v-if="
                            invoiceData.data.dteJson
                              .IdentificacionTipoOperacion == 2
                          "
                        >
                          Por contingencía
                        </td>
                      </tr>
                      <tr></tr>
                    </table>
                  </div>
                </div>

                <br />
                <hr />
                <div
                  style="width: 100%"
                  v-if="
                    invoiceData.data.branch.BranchBannerPath != null &&
                    invoiceData.data.branch.BranchBannerPath != '' &&
                    invoiceData.data.branch.BranchBannerPath != 'null'
                  "
                >
                  <table
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                  >
                    <tr>
                      <td
                        style="
                          padding-left: 0px;
                          padding-right: 0px;
                          padding-bottom: 0px;
                          text-align: center;
                        "
                      >
                        <img
                          style="max-height: 220px"
                          :src="invoiceData.data.branch.BranchBannerPath"
                          width="100%"
                        />
                      </td>
                    </tr>
                  </table>
                </div>
                <br />
                <div style="width: 100%">
                  <table
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                    v-if="invoiceData.data.header.InvoiceType != 'CCF'"
                  >
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Razón social:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceName }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Dirección:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                          width: 300px !important;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceAddress }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NIT:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceNIT }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>DUI:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceDUI }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Entidad:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceEntity }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Moneda:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{
                          invoiceData.data.header.InvoiceCurrency == "$"
                            ? "USD"
                            : ""
                        }}
                      </td>

                      <td
                        v-if="
                          invoiceData.data.header.ZoneClient != '' &&
                          invoiceData.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Zona:</b>
                      </td>
                      <td
                        v-if="
                          invoiceData.data.header.ZoneClient != '' &&
                          invoiceData.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.ZoneClient }}
                      </td>
                    </tr>
                    <tr v-if="!lexlitislatamclientdata">
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Estado de la factura:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceStatusDescription }}
                      </td>
                    </tr>
                  </table>
                  <table
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                    v-else-if="kitcoalternativeposclientdata"
                  >
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Razón social:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceName }}
                      </td>

                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NIT:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceNIT }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Dirección:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                          width: 300px !important;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceAddress }}
                      </td>

                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NRC:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceNRC }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Actividad económica:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.dteJson.ReceptorDescActividad }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Forma de pago:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceStatusDescription }}
                      </td>

                      <td
                        v-if="
                          invoiceData.data.header.ZoneClient != '' &&
                          invoiceData.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Zona:</b>
                      </td>
                      <td
                        v-if="
                          invoiceData.data.header.ZoneClient != '' &&
                          invoiceData.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.ZoneClient }}
                      </td>
                    </tr>
                  </table>
                  <table
                    style="
                      font-size: 10pt;
                      border-collapse: collapse;
                      width: 100%;
                    "
                    v-else
                  >
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Razón social:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceName }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Dirección:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                          width: 300px !important;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceAddress }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NIT:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceNIT }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>NRC:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceNRC }}
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Entidad:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceEntity }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Actividad económica:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.dteJson.ReceptorDescActividad }}
                      </td>

                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Moneda:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{
                          invoiceData.data.header.InvoiceCurrency == "$"
                            ? "USD"
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr v-if="!lexlitislatamclientdata">
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Estado de la factura:</b>
                      </td>
                      <td
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.InvoiceStatusDescription }}
                      </td>

                      <td
                        v-if="
                          invoiceData.data.header.ZoneClient != '' &&
                          invoiceData.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Zona:</b>
                      </td>
                      <td
                        v-if="
                          invoiceData.data.header.ZoneClient != '' &&
                          invoiceData.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.ZoneClient }}
                      </td>
                    </tr>
                    <tr v-else>
                      <td
                        v-if="
                          invoiceData.data.header.ZoneClient != '' &&
                          invoiceData.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        <b>Zona:</b>
                      </td>
                      <td
                        v-if="
                          invoiceData.data.header.ZoneClient != '' &&
                          invoiceData.data.header.ZoneClient != null
                        "
                        style="
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-bottom: 5px;
                        "
                      >
                        {{ invoiceData.data.header.ZoneClient }}
                      </td>
                    </tr>
                  </table>
                </div>
                <template
                  v-if="
                    invoiceData.data.header.InvoiceType == 'DNC' ||
                    invoiceData.data.header.InvoiceType == 'DND'
                  "
                >
                  <br />
                  <div style="width: 100%">
                    <table
                      style="
                        width: 100% !important;
                        font-size: 11px;
                        border-collapse: collapse;
                        border: 1px solid black;
                      "
                    >
                      <tr style="background: gray">
                        <td
                          colspan="3"
                          style="text-align: center; color: white"
                        >
                          DOCUMENTOS RELACIONADOS
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 1px solid;
                            padding-left: 2px;
                            width: 35px;
                          "
                        >
                          Tipo de Documento
                        </td>
                        <td
                          style="
                            border: 1px solid;
                            padding-left: 2px;
                            width: 35px;
                          "
                        >
                          Nº de Documento
                        </td>
                        <td
                          style="
                            border: 1px solid;
                            padding-left: 2px;
                            width: 35px;
                          "
                        >
                          Fecha de Documento
                        </td>
                      </tr>

                      <tr
                        v-for="(item, index) in invoiceData.data.docRelated"
                        :key="index"
                      >
                        <td
                          style="
                            border-left: 1px solid;
                            border-right: 1px solid;
                          "
                        >
                          {{
                            item.TipoDocumentoRelacionado == "03"
                              ? "Comprobante de Crédito Fiscal"
                              : ""
                          }}
                        </td>
                        <td
                          style="
                            border-left: 1px solid;
                            border-right: 1px solid;
                          "
                        >
                          {{ item.NumeroDocumentoRelacionado }}
                        </td>
                        <td
                          style="
                            border-left: 1px solid;
                            border-right: 1px solid;
                          "
                        >
                          {{ item.FechaEmisionRelacionado }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </template>

                <br />
                <div style="width: 100%">
                  <table
                    style="
                      width: 100% !important;
                      font-size: 11px;
                      border-collapse: collapse;
                      border: 1px solid black;
                    "
                  >
                    <tr
                      :style="`background: ${
                        specialinvoicescolor || 'gray'
                      }; color: ${specialInvoicesTitleColor || 'white'};`"
                    >
                      <td colspan="11" style="text-align: center; color: white">
                        CUERPO DEL DOCUMENTO
                      </td>
                    </tr>

                    <tr>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 35px;
                        "
                      >
                        No.<br />Item
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 35px;
                        "
                      >
                        Tipo<br />Item
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 35px;
                        "
                      >
                        Cant.
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 95px;
                        "
                      >
                        Código
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 95px;
                        "
                      >
                        Código<br />Alterno
                      </td>
                      <td style="border: 1px solid; padding-left: 2px">
                        Descripcion
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Precio<br />unitario
                        {{ invoiceData.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Descuento {{ invoiceData.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType != 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Otros
                        <br />montos no
                        <br />afectos
                        {{ invoiceData.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType != 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Ventas<br />exentas
                        {{ invoiceData.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType != 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Ventas no<br />sujetas
                        {{ invoiceData.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType == 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Otros montos no afectos
                        {{ invoiceData.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType != 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Ventas <br />gravadas
                        {{ invoiceData.data.header.InvoiceCurrency }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType == 'FEX'"
                        style="
                          border: 1px solid;
                          padding-left: 2px;
                          width: 65px;
                        "
                      >
                        Ventas <br />afectas
                        {{ invoiceData.data.header.InvoiceCurrency }}
                      </td>
                    </tr>

                    <tr
                      v-for="(item, index) in valuesRows[indexPage]"
                      :key="index"
                    >
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        {{
                          typePrint == 0
                            ? index + 1 + 40 * indexPage
                            : index + 1 + 30 * indexPage
                        }}
                      </td>
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        3
                      </td>
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        {{ item.ItemQuantity }}
                      </td>
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        {{ item.ID_Item }}
                      </td>
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        {{ item.PrincipalBarCode }}
                      </td>
                      <td
                        style="border-left: 1px solid; border-right: 1px solid"
                      >
                        {{ item.ItemDescription }}
                      </td>
                      <td
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemUnitPrice).toFixed(2)
                          )
                        }}
                      </td>
                      <td
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemDiscount).toFixed(2)
                          )
                        }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType != 'FEX'"
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemNoGravada).toFixed(2)
                          )
                        }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType != 'FEX'"
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemExenta).toFixed(2)
                          )
                        }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType != 'FEX'"
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemNoSuj).toFixed(2)
                          )
                        }}
                      </td>
                      <td
                        v-if="invoiceData.data.header.InvoiceType == 'FEX'"
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{ numberWithCommas(parseFloat(0).toFixed(2)) }}
                      </td>
                      <td
                        style="
                          border-left: 1px solid;
                          border-right: 1px solid;
                          text-align: right;
                        "
                      >
                        {{
                          numberWithCommas(
                            parseFloat(item.ItemGravada).toFixed(2)
                          )
                        }}
                      </td>
                    </tr>

                    <tr v-if="indexPage == numPages - 1">
                      <td
                        colspan="7"
                        style="text-align: center; border: 1px solid"
                      >
                        <b>Valor en letras: </b>
                        {{ invoiceData.data.header.InvoiceTotalLetras }}
                      </td>

                      <td colspan="5" style="border: 1px solid">
                        <table
                          style="
                            width: 100% !important;
                            font-size: 11px;
                            text-align: right;
                          "
                        >
                          <template
                            v-if="invoiceData.data.header.InvoiceType == 'CCF'"
                          >
                            <tr>
                              <td>Sub total ventas gravadas</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header
                                        .InvoiceSubTotalVentas
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total descuentos</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalDescu
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(invoiceData.data.header.TurismoPorAlojamiento) >  0">
                              <td>Imp. Turismo</td>
                              <td>{{invoiceData.data.header.InvoiceCurrency}}</td>
                              <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(invoiceData.data.header.TurismoPorAlojamiento).toFixed(2))}}</td>
                            </tr>
                            <tr>
                              <td>IVA</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalIva
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Sub total</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header
                                        .InvoiceMontoTotalOperacion
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>IVA Retenido</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceIvaRete1
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>IVA Percibido</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceIvaPerce1
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Impuesto sobre la renta</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceReteRenta
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total otros montos no afectos</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalNoGravado
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(invoiceData.data.header.Fovial) > 0">
                              <td>Fovial</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.Fovial
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(invoiceData.data.header.Cotrans) > 0">
                              <td>Cotrans</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.Cotrans
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Total</b></td>
                              <td>
                                <b>{{
                                  invoiceData.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalPagar
                                    ).toFixed(2)
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>

                          <template
                            v-if="
                              invoiceData.data.header.InvoiceType == 'FCF' ||
                              invoiceData.data.header.InvoiceType == 'CDD' ||
                              invoiceData.data.header.InvoiceType == 'DNR'
                            "
                          >
                            <tr>
                              <td>Sub total de ventas</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header
                                        .InvoiceSubTotalVentas
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total descuentos</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalDescu
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(invoiceData.data.header.TurismoPorAlojamiento) >  0">
                              <td>Imp. Turismo</td>
                              <td>{{invoiceData.data.header.InvoiceCurrency}}</td>
                              <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(invoiceData.data.header.TurismoPorAlojamiento).toFixed(2))}}</td>
                            </tr>
                            <tr>
                              <td>IVA Retenido</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceIvaRete1
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Impuesto sobre la renta</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceReteRenta
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total otros montos no afectos</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalNoGravado
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(invoiceData.data.header.Fovial) > 0">
                              <td>Fovial</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.Fovial
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(invoiceData.data.header.Cotrans) > 0">
                              <td>Cotrans</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.Cotrans
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Total</b></td>
                              <td>
                                <b>{{
                                  invoiceData.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalPagar
                                    ).toFixed(2)
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>

                          <template
                            v-if="invoiceData.data.header.InvoiceType == 'FEX'"
                          >
                            <tr>
                              <td>Total de Operaciones Afectas</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header
                                        .InvoiceSubTotalVentas
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Monto global de Desc., Rebajas de operaciones
                                afectas
                              </td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalDescu
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Flete</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.Flete
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Seguro</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.Seguro
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Monto Total de la Operación</b></td>
                              <td>
                                <b>{{
                                  invoiceData.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalPagar
                                    ).toFixed(2)
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>

                          <template
                            v-if="invoiceData.data.header.InvoiceType == 'FNS'"
                          >
                            <tr>
                              <td>Sub total de ventas</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header
                                        .InvoiceSubTotalVentas
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total descuentos</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalDescu
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>IVA Retenido</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceIvaRete1
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Impuesto sobre la renta</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceReteRenta
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Total</b></td>
                              <td>
                                <b>{{
                                  invoiceData.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalPagar
                                    ).toFixed(2)
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>

                          <template
                            v-if="
                              invoiceData.data.header.InvoiceType == 'DNC' ||
                              invoiceData.data.header.InvoiceType == 'DND'
                            "
                          >
                            <tr>
                              <td>Sub total de ventas</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header
                                        .InvoiceSubTotalVentas
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Monto global Des., Rebajas y otros a ventas no
                                sujetas
                              </td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceDescuNoSuj
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Monto global Des., Rebajas y otros a ventas
                                exentas
                              </td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceDescuExenta
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Monto global Des., Rebajas y otros a ventas
                                gravadas
                              </td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceDescuGravada
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr v-if="parseFloat(invoiceData.data.header.TurismoPorAlojamiento) >  0">
                              <td>Imp. Turismo</td>
                              <td>{{invoiceData.data.header.InvoiceCurrency}}</td>
                              <td style="text-align: right; width: 50px;">{{numberWithCommas(parseFloat(invoiceData.data.header.TurismoPorAlojamiento).toFixed(2))}}</td>
                            </tr>
                            <tr>
                              <td>Impuesto al Valor Agregado 13%</td>
                              <td>
                                {{ invoiceData.data.header.InvoiceCurrency }}
                              </td>
                              <td style="text-align: right; width: 50px">
                                {{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalIva
                                    ).toFixed(2)
                                  )
                                }}
                              </td>
                            </tr>
                            <tr style="font-size: 12px">
                              <td><b>Total</b></td>
                              <td>
                                <b>{{
                                  invoiceData.data.header.InvoiceCurrency
                                }}</b>
                              </td>
                              <td style="text-align: right; width: 50px">
                                <b>{{
                                  numberWithCommas(
                                    parseFloat(
                                      invoiceData.data.header.InvoiceTotalPagar
                                    ).toFixed(2)
                                  )
                                }}</b>
                              </td>
                            </tr>
                          </template>
                        </table>
                      </td>
                    </tr>
                    <template v-if="invoiceData.data.header.InvoiceInternalNote">
                      <tr>
                        <td colspan="10" style="padding: 5px">
                          <b>Observaciones: </b> {{ commentsOuterHtml }}
                        </td>
                      </tr>
                    </template>
                  </table>
                </div>
              </div>

              <div
                style="position: absolute; bottom: 0; width: 100%; left: 80px"
              >
                <p style="font-size: 10px">
                  Pagina {{ indexPage + 1 }} de {{ numPages }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc";
import { numberWithCommas } from "../../helpers/money";

export default {
  name: "PrintPdfInvoiceGenerator",
  props: {
    invoiceData: {
      type: Object,
      required: true,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      numPages: 0,
      valuesRows: [],
      urlQr: null,
      typePrint: 0,
      specialinvoicescolor: JSON.parse(localStorage.getItem("user"))
        .specialinvoicescolor,
      specialInvoicesTitleColor: JSON.parse(localStorage.getItem("user"))
        .specialInvoicesTitleColor,
      kitcoalternativeposclientdata: JSON.parse(localStorage.getItem("user"))
        .kitcoalternativeposclientdata,
      lexlitislatamclientdata: JSON.parse(localStorage.getItem("user"))
        .lexlitislatamclientdata,
      ShowCorrelativeControl: JSON.parse(localStorage.getItem("user")).showcorrelativecontrol,
      // Cache para QR codes
      qrCache: new Map(),
    };
  },
  async mounted() {
    try {
      await this.calculatePagesOfDoc();
      await this.setupComponent();
    } catch (err) {
      console.error('Error en PrintPdfInvoiceGenerator:', err);
      throw err;
    }
  },
  computed: {
    BillingNrc() {
      return addFormatNRC(this.invoiceData.data.branch.BusinessBillingNRC);
    },
    BillingNit() {
      return addFormatToNIT(this.invoiceData.data.branch.BusinessBillingNIT);
    },
    pages() {
      return Array.from({ length: this.numPages });
    },
    commentsOuterHtml() {
      return this.invoiceData.data.header.InvoiceInternalNote?.replace(
        /<[^>]*>/g,
        ""
      ) || '';
    },
    modifiedBranchBilledInfo() {
      const info = this.invoiceData.data.branch.BranchBilledInfo;
      if (info && info !== "") {
        return info.replace(/<p>/g, "").replace(/<\/p>/g, "<br/>");
      }
      return null;
    },
  },
  methods: {
    async setupComponent() {
      try {
        const partes = this.invoiceData.data.header.InvoiceDate.split("/");
        const dia = partes[0];
        const mes = partes[1];
        const anio = partes[2];

        const fechaNueva = `${anio}-${mes}-${dia}`;
        const url =
          this.invoiceData.data.branch.AuthFeMode == 1
            ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.invoiceData.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
            : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.invoiceData.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

        // Cache QR code si ya existe
        if (this.qrCache.has(url)) {
          this.urlQr = this.qrCache.get(url);
          return;
        }

        const opt = {
          errorCorrectionLevel: "H",
          type: "image/png",
          quality: 0.3,
          margin: 1,
          color: {
            dark: "#000000",
            light: "#ffffff",
          },
          width: 100,
        };

        // Generar QR de forma síncrona usando Promise
        this.urlQr = await new Promise((resolve, reject) => {
          QRCode.toDataURL(url, opt, (error, qrUrl) => {
            if (error) {
              reject(error);
            } else {
              // Guardar en cache
              this.qrCache.set(url, qrUrl);
              resolve(qrUrl);
            }
          });
        });
      } catch (error) {
        console.error('Error en setupComponent:', error);
        throw error;
      }
    },

    numberWithCommas(x) {
      return numberWithCommas(x);
    },

    calculatePagesOfDoc() {
      let pages = 0;
      let rows = 0;
      this.valuesRows[pages] = [];

      try {
        if (
          this.invoiceData.data.branch.BusinessBillingNRC == "3213715" ||
          this.invoiceData.data.branch.BusinessBillingNRC == "2201050"
        ) {
          this.typePrint = 1;
          if (this.invoiceData.data.body.length <= 24) {
            for (let i = 0; i < this.invoiceData.data.body.length; i++) {
              rows++;
              this.valuesRows[pages].push(this.invoiceData.data.body[i]);
            }
          } else {
            for (let i = 0; i < this.invoiceData.data.body.length; i++) {
              if (rows < 29 && i !== this.invoiceData.data.body.length - 1) {
                rows++;
                this.valuesRows[pages].push(this.invoiceData.data.body[i]);
              } else if (rows <= 24) {
                rows++;
                this.valuesRows[pages].push(this.invoiceData.data.body[i]);
              } else {
                this.valuesRows[pages].push(this.invoiceData.data.body[i]);
                pages++;
                rows = 0;
                this.valuesRows[pages] = [];
              }
            }
          }
        } else {
          this.typePrint = 0;
          if (this.invoiceData.data.body.length <= 34) {
            for (let i = 0; i < this.invoiceData.data.body.length; i++) {
              rows++;
              this.valuesRows[pages].push(this.invoiceData.data.body[i]);
            }
          } else {
            for (let i = 0; i < this.invoiceData.data.body.length; i++) {
              if (rows < 39 && i !== this.invoiceData.data.body.length - 1) {
                rows++;
                this.valuesRows[pages].push(this.invoiceData.data.body[i]);
              } else if (rows <= 34) {
                rows++;
                this.valuesRows[pages].push(this.invoiceData.data.body[i]);
              } else {
                this.valuesRows[pages].push(this.invoiceData.data.body[i]);
                pages++;
                rows = 0;
                this.valuesRows[pages] = [];
              }
            }
          }
        }
      } catch (err) {
        console.error('Error en calculatePagesOfDoc:', err);
        throw err;
      }
      pages = pages + 1;
      this.numPages = pages;
    },

    async generatePDF() {
      try {
        const doc = new jsPDF("p", "pt", "letter");
        
        // Configuración ultra-optimizada para procesamiento masivo
        const optimizedOptions = {
          callback: function (doc) {
            doc.output();
          },
          x: 0,
          y: 0,
          margin: [0, 0, 0, 0],
          html2canvas: {
            scale: 0.612,
          //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
          useCORS: true,
          logging: false,
          allowTaint: true,
            // Desactivar recursos innecesarios
            ignoreElements: (element) => {
              return element.classList?.contains('v-ripple__container') || 
                     element.classList?.contains('v-overlay') ||
                     element.tagName === 'SCRIPT' ||
                     element.id === 'app' ||
                     element.classList?.contains('v-application');
            },
          },
        };

        await doc.html(this.$refs.dataprint, optimizedOptions);

        return doc;
      } catch (error) {
        console.error('Error generando PDF:', error);
        throw error;
      }
    },

    // Método para limpiar cache de QR si es necesario
    clearQrCache() {
      this.qrCache.clear();
    }
  },
};
</script>

<style scoped>
* {
  font-family: Arial, Helvetica, sans-serif !important;
}
</style>